import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { ResetPasswordModel } from './model/ResetPasswordModel';
import { ResetPasswordController } from './controller/ResetPasswordController';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem, Navigation } from 'utils/Navigation';
import { AuthCard } from '../AuthCard';
import { TextField } from 'components/input/TextField';
import { Button } from '@material-ui/core';

export class ResetPasswordScene extends AScene<Props, ResetPasswordModel, ResetPasswordController> {

    private password: string = "";

    public constructor(props: Props) {
        super(props);

        this.handleSubmitClicked = this.handleSubmitClicked.bind(this);
    }

    protected createControlller(): ResetPasswordController {
        return new ResetPasswordController();
    }

    private handleSubmitClicked() {
        this.controller.onSubmitClicked(this.password);
    }

    public render(): React.ReactNode {
        if (this.model.isInit) {
            return (<></>);
        }

        if (!this.model.valid) {
            return (
                <AuthCard title="Reset password" error={this.model.globalError}>
                    <div style={{ textAlign: 'center', fontSize: '14px' }}>
                        <a href="/forgotPassword.rsc" style={{ color: '#009155' }} onClick={(e) => { e.preventDefault(); Navigation.pushState(null, "/forgotPassword.rsc"); }}>Request a new reset link</a>
                    </div>
                </AuthCard>
            );
        }

        this.password = this.model.password;
        return (
            <AuthCard title="Reset password" error={this.model.globalError}>
                <div style={{ textAlign: 'center', fontSize: '15px', color: '#888', marginBottom: '24px' }}>
                    Choose a new password for your account.
                </div>
                <TextField label="New password" type="password" value={this.model.password} desc="Minimum 6, maximum 64 characters." error={this.model.passwordError} onChange={(v) => { this.password = v; }} />
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginTop: '8px' }}>
                    <Button color="primary" variant="contained" onClick={this.handleSubmitClicked}>Set new password</Button>
                </div>
            </AuthCard>
        );
    }

}

export class Props {

}

export class ResetPasswordSceneFactory implements ISceneFactory {

    create(historyItem: HistoryItem): React.ReactNode {
        return (
            <ResetPasswordScene />
        );
    }

}
